import React from "react";
import SelectFilter from "../selectFilter";
import { DECLARANT_MISTAKES } from "../../../../../constants/values";
import { IFilterProps } from "../Interfaces";

const MistakesFilter: React.FC<IFilterProps> = ({
  setSelectedKeys,
  confirm,
  clearFilters,
  selectedKeys,
  multiple,
}) => (
  <SelectFilter
    setSelectedKeys={setSelectedKeys}
    confirm={confirm}
    clearFilters={clearFilters}
    options={DECLARANT_MISTAKES}
    selectedKeys={selectedKeys}
    multiple={multiple}
  />
);

export default MistakesFilter;
